import React from 'react';
import { Col, Navbar } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const Header = React.lazy(() =>
  import("../../Components/Header/Header").then((module) => ({
    default: module.Header,
  }))
);

const HeaderNav = React.lazy(() =>
  import('../../Components/Header/Header').then((module) => ({
    default: module.HeaderNav,
  }))
);

const Menu = React.lazy(() =>
  import('../../Components/Header/Header').then((module) => ({
    default: module.Menu,
  }))
);

const HeaderSection = (props) => {
  return (
    <Header topSpace={{ md: true }} type="reverse-scroll">
      <HeaderNav
        fluid="fluid"
        theme="light"
        expand="lg"
        className="glass-panel py-[10px] px-[40px] md:px-[15px] md:py-[10px] sm:px-[10px] fixed top-0 w-full z-50 transition-all duration-300"
        style={{ marginTop: '15px', borderRadius: '50px', width: '95%', left: '50%', transform: 'translateX(-50%)', border: '1px solid rgba(255,255,255,0.7)', padding: '0 20px' }}
      >
        {/* Logo */}
        <Col lg={2} sm={6} xs={"auto"} className="mr-auto ps-0">
          <Link aria-label="header logo" className="flex items-center" to="/">
            <img
              width="120"
              height="40"
              src="/assets/img/webp/logo02.png"
              alt="Pambazuka Events"
              style={{ transition: 'opacity 0.3s ease' }}
            />
          </Link>
        </Col>

        {/* Mobile Toggle */}
        <Navbar.Toggle className="md:ml-[17px] w-[25px] min-h-[15px] inline-block align-middle">
          <span className="navbar-toggler-line"></span>
          <span className="navbar-toggler-line"></span>
          <span className="navbar-toggler-line"></span>
          <span className="navbar-toggler-line"></span>
        </Navbar.Toggle>

        {/* Navigation Menu */}
        <Navbar.Collapse className="justify-end col-auto col-lg-8">
          <Menu {...props} />
        </Navbar.Collapse>
      </HeaderNav>
    </Header>
  );
};

export default HeaderSection;
